import { defineEffect } from '../../../core/effect';
import { posChangeMotionSpec } from '../fx/posChange';

/** 表示形式の変更（裏 ↔ 表）の **motion**: 盤のカードが浮いて開く（Issue #589。状況は共通側の `editorPorts/duelSituations/pos_change.js` が決め、絵の組み立ては `../fx/posChange.js`） */
export default defineEffect({ situation: 'pos_change_flip', role: 'motion', ...posChangeMotionSpec('flip') }, 'pos_change_flip_motion.js');
